import React, { memo } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  const benefits = ['48 actividades de activación cognitiva listas para imprimir y usar', 'Ejercicios diarios para la memoria, la atención y la concentración', 'Actividades familiares para hacer juntos y construir recuerdos nuevos', 'Sistema progresivo que va de lo más simple a lo más desafiante', 'Diseñado para adultos mayores que viven en Argentina', 'Sin tecnología, sin aplicaciones, sin complicaciones'];
  return <section className="pt-2 pb-2 px-3 md:pt-24 md:pb-16 md:px-4 max-w-4xl mx-auto text-center min-h-[100svh] md:min-h-0 flex flex-col justify-center" data-id="element-153">
      <p className="text-teal-700 font-semibold tracking-wide uppercase text-[9px] leading-snug md:text-base mb-1 md:mb-6 px-2" data-id="element-154">
        PARA EL QUE VE CÓMO SU PAPÁ, SU MAMÁ O SU ABUELO/A SE VA APAGANDO DE A
        POCO Y NO SABE QUÉ HACER…
      </p>

      <h1 className="text-[26px] md:text-7xl font-extrabold text-slate-900 mb-0.5 md:mb-4 tracking-tight leading-none" data-id="element-155">
        Mente Activa
      </h1>

      <h2 className="text-[13px] md:text-3xl font-medium text-slate-700 mb-1 md:mb-8 leading-snug px-2" data-id="element-156">
        El sistema completo de activación mental para adultos mayores
      </h2>

      <p className="text-[11px] md:text-xl text-slate-600 mb-1.5 md:mb-10 max-w-2xl mx-auto leading-snug md:leading-relaxed px-2" data-id="element-157">
        La memoria no cambia de un día para otro, pero sí necesita estímulo
        diario para mantenerse activa.
      </p>

      <div className="mb-2 md:mb-12 max-w-[130px] md:max-w-xl mx-auto" data-id="element-158">
        <img src="https://cdn.magicpatterns.com/uploads/dmAmaJRonpVM6PTXPaMjUc/ChatGPT_Image_5_may_2026__02_08_23_p.m.-removebg-preview.png" alt="Mente Activa - Sistema de Activación Mental" onClick={() => document.getElementById('checkout')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full h-auto cursor-pointer drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-159" />
      </div>

      <div className="bg-white border border-orange-200 rounded-xl md:rounded-2xl p-2.5 md:p-8 text-left mb-2 md:mb-10 shadow-xl" data-id="element-160">
        <p className="text-center font-bold text-slate-900 mb-1.5 md:mb-6 text-[11px] md:text-lg border-b border-orange-100 pb-1.5 md:pb-4" data-id="element-161">
          NUEVO — 6 Tomos + 4 Bonos · Descarga inmediata
        </p>

        <ul className="space-y-0.5 md:space-y-4 mb-2 md:mb-8" data-id="element-162">
          {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-1.5 md:gap-3" data-id="element-163">
              <CheckCircle2 className="w-3 h-3 md:w-6 md:h-6 text-teal-600 shrink-0 mt-0.5" data-id="element-164" />
              <span className="text-slate-700 text-[10px] leading-tight md:text-lg md:leading-normal" data-id="element-165">
                {benefit}
              </span>
            </li>)}
        </ul>

        <div className="text-center mt-1.5 md:mt-8" data-id="element-166">
          <p className="text-slate-600 mb-1.5 md:mb-4 font-medium text-[10px] md:text-base" data-id="element-167">
            Pago único de $19.990 ARS · Acceso inmediato
          </p>
          <CTAButton text="SÍ, QUIERO MENTE ACTIVA →" className="!py-2 !px-3 !text-[13px] md:!py-4 md:!px-8 md:!text-xl" data-id="element-168" />
        </div>
      </div>
    </section>;
}